import { toSlug } from "./formatters";

export type ProductTypeOption = { id: string; label: string };

export type ProductTypeSelection = {
  productType: string;
  productTypeId: string;
};

/**
 * Resolve a product type to the real Firestore document id.
 * Existing options are matched by id first and label second. Unknown labels
 * (for example a new AI suggestion) get a canonical slug until they are saved.
 */
export function resolveProductTypeSelection(
  options: ProductTypeOption[],
  value: string
): ProductTypeSelection {
  const raw = String(value || "").trim();
  if (!raw) return { productType: "", productTypeId: "" };

  const list = Array.isArray(options) ? options : [];
  const byId = list.find((option) => option.id === raw);
  if (byId) return { productType: byId.label, productTypeId: byId.id };

  const byExactLabel = list.find((option) => option.label === raw);
  if (byExactLabel) {
    return { productType: byExactLabel.label, productTypeId: byExactLabel.id };
  }

  const folded = raw.toLocaleLowerCase("sv");
  const byFoldedLabel = list.find(
    (option) => option.label.toLocaleLowerCase("sv") === folded
  );
  if (byFoldedLabel) {
    return { productType: byFoldedLabel.label, productTypeId: byFoldedLabel.id };
  }

  return { productType: raw, productTypeId: toSlug(raw) };
}
